module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Thin.44f3670.woff";